/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2/25/21
 * Copyright All Rights Reserved
 */
// @flow
import { getOr } from 'lodash/fp';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { Form, FormGroup, Label, Col } from 'reactstrap';
import { Field } from 'redux-form';
import SubmitButton from 'components/support/buttons/SubmitButton';
import FieldFeedback from 'components/support/forms/FieldFeedback';
import RenderInput from 'components/support/forms/RenderInput';
import Tip from 'components/support/tooltips/Tip';
import { CREATE_PASSWORD_FORM } from 'constants/forms';
import {
  emptyOrMinLength8,
  hasLowerCaseLetters,
  hasSpecialCharacters,
  required,
  sameAsNewPassword,
} from 'support/validators';

type Props = {
  error?: string,
  location: {
    state?: {
      from: string,
    }
  },
  handleSubmit: Function,
  submitting: boolean,
  tokenIsSet: boolean,
  orgIsSet: boolean,
}

const CreatePasswordForm = (props: Props) => {
  const {
    error, location, handleSubmit, submitting, tokenIsSet, orgIsSet,
  } = props;
  if (tokenIsSet && orgIsSet) {
    return (
      <Redirect to={{ pathname: getOr('/inventory', 'state.from', location) }} />
    );
  }
  const alert = error ? <div className="alert alert-danger">{error}</div> : null;
  return (
    <Form className="create-password-form" onSubmit={handleSubmit}>
      {alert}
      <FormGroup row>
        <Col lg="6">
          <Label htmlFor="newPassword">
            New Password
          </Label>
          {' '}
          <Tip tipId="newPassword" />
          <Field
            id="newPassword"
            name="newPassword"
            type="password"
            component={RenderInput}
            validate={[required, hasLowerCaseLetters, hasSpecialCharacters, emptyOrMinLength8]}
          />
          <FieldFeedback name="newPassword" form={CREATE_PASSWORD_FORM} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Col lg="6">
          <Label htmlFor="confirmPassword">
            Confirm Password
          </Label>
          <Field
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            component={RenderInput}
            validate={[required, sameAsNewPassword]}
          />
          <FieldFeedback name="confirmPassword" form={CREATE_PASSWORD_FORM} />
        </Col>
      </FormGroup>
      <SubmitButton color="primary" type="submit" formNoValidate submitting={submitting}>
        Submit
      </SubmitButton>
    </Form>
  );
};

CreatePasswordForm.defaultProps = {
  error: '',
};

export default CreatePasswordForm;



// WEBPACK FOOTER //
// ./js/components/pages/SignIn/CreatePasswordForm/CreatePasswordForm.jsx